var map = {
	"./aircon-truck.png": 1318,
	"./aircraft.png": 1319,
	"./airstarter.png": 1320,
	"./airtug.png": 1321,
	"./ambulance.png": 1322,
	"./bed.png": 1323,
	"./bicycle.png": 1324,
	"./boom-lift.png": 1325,
	"./bowser.png": 1326,
	"./boy.png": 1327,
	"./bulldozer.png": 1328,
	"./bus.png": 1329,
	"./car.png": 1330,
	"./catering-hi-lift.png": 1331,
	"./cement-mixer.png": 1332,
	"./crane.png": 1333,
	"./defueller.png": 1334,
	"./dispenser.png": 1335,
	"./excavator.png": 1336,
	"./female.png": 1337,
	"./fire-tender.png": 1338,
	"./forklift.png": 1339,
	"./galley-cart.png": 1340,
	"./garbage-wagon.png": 1341,
	"./girl.png": 1342,
	"./helmet.png": 1343,
	"./infant.png": 1344,
	"./invalid-passenger-lift.png": 1345,
	"./joint-pallet-container-loader.png": 1346,
	"./lavatory-truck.png": 1347,
	"./lorry.png": 1348,
	"./main-deck-loader.png": 1349,
	"./maintenance-platform.png": 1350,
	"./male.png": 1351,
	"./mechanical-sweeper.png": 1352,
	"./mini-bus.png": 1353,
	"./mobile-gpu.png": 1354,
	"./motorcycle.png": 1355,
	"./others.png": 1356,
	"./passenger-step.png": 1357,
	"./pmd.png": 1358,
	"./police-car.png": 1359,
	"./prime-mover.png": 1360,
	"./recovery-truck.png": 1361,
	"./scissor-lift.png": 1362,
	"./scooter.png": 1363,
	"./scrubber.png": 1364,
	"./seatbelt.png": 1365,
	"./ship.png": 1366,
	"./skyloader.png": 1367,
	"./storage-bin.png": 1368,
	"./tanker.png": 1369,
	"./tm-compressor.png": 1370,
	"./tm-gpu.png": 1371,
	"./towed-skyloader.png": 1372,
	"./tractor.png": 1373,
	"./trailer.png": 1374,
	"./tram.png": 1375,
	"./transporter.png": 1376,
	"./van.png": 1377,
	"./water-truck.png": 1378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1317;